var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="empty"> <div class="card-body d-flex align-items-start profile-feed-item" style="border-bottom-width:0px"> <img src="'+
((__t=( model.QRCodeImageUrl ))==null?'':__t)+
'" alt="profile" class="" style="height:100px;width:100px"> <div class="ml-4"> <h6> '+
((__t=( model.EventName ))==null?'':__t)+
'  </h6> <p> <i class="mdi mdi mdi-star mr-1"></i> '+
((__t=( model.Description ))==null?'':__t)+
' </p> <button type="button" id="customEventTemplateListItem_btnCreateEvent" class="btn btn-outline-secondary btn-sm">'+
((__t=( resources['X101478'] ))==null?'':__t)+
'</button> </div> </div> <div class="card-body"> <div class="row">   </div> <div id="owlCarouselList"></div>  </div>  </div>';
}
return __p;
};
